import React, { Component } from "react";
import { Col, Row, FormGroup, Label, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
import {
  addFoodDeliveryBoy,
  getFoodDeliveryBoyList,
  getFoodDeliveryBoyById,
  updateFoodDeliveryBoy,
  removeFoodDeliveryBoy,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Table, Chip, Btn, IconBtn, SearchPill, ChipTabs, StatRow, MiniStat, Avatar, ConfirmDialog,
} from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";

/**
 * Delivery riders — the food delivery roster, restyled onto the console shell.
 *
 * The tiles and the status chips are read off the same list payload the table
 * renders, so nothing on the page can disagree with anything else on it: a
 * rider record carries whether they are signed in, out on a delivery and
 * holding an assignment, and those are the only operational facts it carries.
 * Delivery counts, ratings and earnings are not on the record and are not
 * implied here.
 *
 * Re-skin only: addFoodDeliveryBoy / updateFoodDeliveryBoy are called with
 * exactly the object the previous screen sent.
 */

const fullName = (u) => `${u.firstName || ""} ${u.lastName || ""}`.trim();

/** Where a rider is right now, from the flags the record actually carries. */
const riderState = (u) => {
  if (u.DeliveryBoyOutForDelivery) return "out";
  if (u.isOrderAssigned) return "assigned";
  if (u.isLoggedIn) return "online";
  return "offline";
};

/** What a person drives. Missing on older records = delivery. */
const DRIVER_TYPES = [
  { value: "delivery", label: "Food delivery", hint: "Gets home-delivery orders in the driver app." },
  { value: "chauffeur", label: "Chauffeur", hint: "Rides only — picked from the transport driver list, not sent food orders." },
  { value: "both", label: "Both", hint: "Food deliveries, and pickable for rides." },
];
const DRIVER_TYPE_LABEL = { delivery: "Delivery", chauffeur: "Chauffeur", both: "Delivery + rides" };

const STATE_CHIP = {
  out: { tone: "warn", label: "Out for delivery" },
  assigned: { tone: "neutral", label: "Order assigned" },
  online: { tone: "good", label: "Signed in" },
  offline: { tone: "neutral", label: "Signed out" },
};

class DeliveryBoy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      modal: false,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      driverType: "delivery",
      dBoyId: "",
      handleResponse: null,
      // View-only state — never changes what is fetched.
      search: "",
      filter: "",
      showDeleteModal: false,
      pendingDelete: null,
      actionLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      driverType: "delivery",
      dBoyId: "",
    });
  }

  handleCloseModal() {
    this.setState({
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit() {
    // AvForm has already blocked the browser's own submit before calling this.
    const userObject = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      mobile: this.state.mobile,
      country: this.state.country,
      postalCode: this.state.postalCode,
      // chauffeur / both also make the person pickable as a ride driver.
      driverType: this.state.driverType || "delivery",
      dBoyId: this.state.dBoyId,
    };
    if (this.state.dBoyId == "" || this.state.dBoyId == null) {
      addFoodDeliveryBoy(userObject)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                country: "",
                postalCode: "",
                dBoyId: "",
              },
            });
            this.getALlluser();
            this.handleCloseModal();
            toast.success(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateFoodDeliveryBoy(userObject)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",

                dBoyId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();
            toast.success(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  getALlluser() {
    getFoodDeliveryBoyList().then((result) => {
      this.setState({
        isLoaded: true,
        items: (result && result.data) || [],
      });
    });
  }

  removeDeliveryBoy(id) {
    this.setState({ actionLoading: true });
    removeFoodDeliveryBoy(id)
      .then((results) => {
        toast.success(results.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({
          actionLoading: false,
          showDeleteModal: false,
          pendingDelete: null,
        });
      });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editDeliveryBoy(id) {
    getFoodDeliveryBoyById(id)
      .then((results) => {
        this.setState({
          dBoyId: results.data._id,
          firstName: results.data.firstName,
          lastName: results.data.lastName,
          email: results.data.email,
          mobile: results.data.mobile,
          country: results.data.country,
          postalCode: results.data.postalCode,
          driverType: results.data.driverType || "delivery",
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.setState({ modal: true });
  }

  // --- presentation ---------------------------------------------------------

  askDelete = (u) => this.setState({ showDeleteModal: true, pendingDelete: u });

  toggleDeleteModal = () =>
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      pendingDelete: null,
    });

  /** Client-side filter over the loaded roster. No request is made. */
  visibleRiders() {
    const { items, search, filter } = this.state;
    const q = search.trim().toLowerCase();
    return (items || []).filter((u) => {
      if (filter === "working" && riderState(u) === "offline") return false;
      if (filter === "out" && !u.DeliveryBoyOutForDelivery) return false;
      if (filter === "offline" && riderState(u) !== "offline") return false;
      if (!q) return true;
      return [fullName(u), u.email, u.mobile, u.country]
        .some((v) => String(v || "").toLowerCase().includes(q));
    });
  }

  columns() {
    const write = canWrite();
    return [
      {
        key: "rider",
        label: "Rider",
        render: (u) => (
          <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <Avatar name={fullName(u)} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, color: C.ink }}>
                {fullName(u) || "Unnamed rider"}
              </div>
              <div style={{ fontSize: 12, color: C.taupeLight }}>
                {u.mobile || "No phone"}
              </div>
            </div>
          </div>
        ),
      },
      {
        key: "email",
        label: "Email",
        render: (u) => (
          <span style={{ color: u.email ? C.brownDeep : C.taupeLight }}>
            {u.email || "—"}
          </span>
        ),
      },
      {
        key: "country",
        label: "Country",
        width: 150,
        render: (u) => (
          <span style={{ color: u.country ? C.brownDeep : C.taupeLight }}>
            {u.country || "—"}
          </span>
        ),
      },
      {
        key: "driverType",
        label: "Drives",
        width: 150,
        render: (u) => <Chip tone="neutral">{DRIVER_TYPE_LABEL[u.driverType] || DRIVER_TYPE_LABEL.delivery}</Chip>,
      },
      {
        key: "status",
        label: "Right now",
        width: 170,
        render: (u) => {
          const s = STATE_CHIP[riderState(u)];
          return <Chip tone={s.tone}>{s.label}</Chip>;
        },
      },
      {
        key: "createdAt",
        label: "Joined",
        width: 130,
        render: (u) =>
          u.createdAt ? (
            moment(u.createdAt).format("D MMM YYYY")
          ) : (
            <span style={{ color: C.taupeLight }}>—</span>
          ),
      },
      // Write controls stay behind canWrite(): a view-only account still sees
      // the whole roster, just no way to change it.
      ...(write
        ? [
            {
              key: "actions",
              label: "",
              width: 96,
              align: "right",
              render: (u) => (
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <IconBtn
                    icon="edit"
                    title={`Edit ${fullName(u) || "rider"}`}
                    onClick={() => this.editDeliveryBoy(u._id.toString())}
                  />
                  <IconBtn
                    icon="delete"
                    tone="bad"
                    title={`Remove ${fullName(u) || "rider"}`}
                    onClick={() => this.askDelete(u)}
                  />
                </div>
              ),
            },
          ]
        : []),
    ];
  }

  renderModal() {
    const { dBoyId } = this.state;
    const editing = !!dBoyId;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className="con-modal" centered>
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <span
              className="ms"
              style={{
                fontSize: 26,
                color: C.brown,
                background: C.iconTint,
                padding: 13,
                borderRadius: 16,
              }}
            >
              delivery_dining
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit rider" : "Add rider"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Contact details used when a delivery is assigned"
                  : "Creates the account the rider signs into the driver app with"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0,
                background: "transparent",
                color: C.taupeLight,
                cursor: "pointer",
                padding: 4,
                lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 24 }}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="firstName">First name</Label>
                    <AvField
                      type="text"
                      value={this.state.firstName}
                      onChange={this.handleChange}
                      id="firstName"
                      name="firstName"
                      required
                                  errorMessage="First name is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="lastName">Last name</Label>
                    <AvField
                      type="text"
                      value={this.state.lastName}
                      onChange={this.handleChange}
                      id="lastName"
                      name="lastName"
                      required
                                  errorMessage="Last name is required"
                                />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <AvField
                      type="text"
                      value={this.state.email}
                      onChange={this.handleChange}
                      id="email"
                      name="email"
                      required
                                  errorMessage="Email is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="mobile">Mobile</Label>
                    <AvField
                      type="number"
                      min={0}
                      value={this.state.mobile}
                      onChange={this.handleChange}
                      id="mobile"
                      name="mobile"
                      required
                                  errorMessage="Mobile is required"
                                />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="country">Country</Label>
                    <AvField
                      type="text"
                      value={this.state.country}
                      onChange={this.handleChange}
                      id="country"
                      name="country"
                      required
                                  errorMessage="Country is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="driverType">Drives</Label>
                    <AvField type="select" value={this.state.driverType} onChange={this.handleChange} id="driverType" name="driverType">
                      {DRIVER_TYPES.map((t) => (
                        <option key={t.value} value={t.value}>{t.label}</option>
                      ))}
                    </AvField>
                    <div style={{ marginTop: 6, fontSize: 12, color: C.taupeLight }}>
                      {(DRIVER_TYPES.find((t) => t.value === this.state.driverType) || DRIVER_TYPES[0]).hint}
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </div>

            <div style={{ marginTop: 8, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1,
                  height: 52,
                  border: "1px solid #e6d8c4",
                  borderRadius: 26,
                  background: "#fff",
                  color: C.slate,
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              {/* Stays a real submit button — AvForm validates on submit. */}
              <button
                type="submit"
                style={{
                  flex: 1,
                  height: 52,
                  border: 0,
                  borderRadius: 26,
                  background: C.brown,
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add rider"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, filter, pendingDelete } = this.state;
    const write = canWrite();
    const visible = this.visibleRiders();
    const all = items || [];
    const online = all.filter((u) => u.isLoggedIn).length;
    const out = all.filter((u) => u.DeliveryBoyOutForDelivery).length;
    const assigned = all.filter((u) => u.isOrderAssigned).length;
    const offline = all.filter((u) => riderState(u) === "offline").length;

    return (
      <ConsolePage
        title="Delivery riders"
        subtitle={
          isLoaded
            ? `${all.length} rider${all.length === 1 ? "" : "s"}${
                search.trim() ? ` · ${visible.length} matching` : ""
              }`
            : "Loading riders…"
        }
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Name, phone or email"
              width={250}
            />
            {write && (
              <Btn icon="person_add" onClick={this.toggle}>
                Add rider
              </Btn>
            )}
          </React.Fragment>
        }
      >

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow>
            <MiniStat label="Riders on the roster" value={all.length} hint="Verified accounts" />
            <MiniStat label="Signed in" value={online} hint="Reachable in the driver app" />
            <MiniStat
              label="Out for delivery"
              value={out}
              tone={out > 0 ? "warn" : undefined}
              hint="Currently on the road"
            />
            <MiniStat label="Holding an order" value={assigned} hint="Assigned, not yet delivered" />
          </StatRow>

          <ChipTabs
            value={filter}
            onChange={(v) => this.setState({ filter: v })}
            options={[
              { value: "", label: "All", count: all.length },
              { value: "working", label: "Working", count: all.length - offline },
              { value: "out", label: "Out for delivery", count: out },
              { value: "offline", label: "Signed out", count: offline },
            ]}
          />

          <Panel style={{ padding: 0 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
                padding: "16px 22px",
                borderBottom: `1px solid ${C.panel}`,
              }}
            >
              <div>
                <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>The roster</div>
                <div style={{ marginTop: 3, fontSize: 13, color: C.taupeLight }}>
                  Riders you can assign a food delivery to
                </div>
              </div>
              <div style={{ fontSize: 14, color: C.taupeLight }}>
                {visible.length} of {all.length} shown
              </div>
            </div>

            <div style={{ padding: "6px 8px" }}>
              {!isLoaded ? (
                <div style={{ padding: "48px 0", textAlign: "center", color: C.taupeLight }}>
                  Loading riders…
                </div>
              ) : (
                <Table
                  columns={this.columns()}
                  rows={visible}
                  empty={
                    all.length === 0
                      ? "No delivery riders yet — add one to start assigning deliveries"
                      : "No rider matches this filter."
                  }
                />
              )}
            </div>
          </Panel>
        </div>

        {this.renderModal()}

        <ConfirmDialog
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={() =>
            pendingDelete && this.removeDeliveryBoy(pendingDelete._id.toString())
          }
          icon="delete"
          title={`Remove ${
            pendingDelete ? fullName(pendingDelete) || "this rider" : "this rider"
          }?`}
          body="They can no longer sign into the driver app or be assigned a delivery."
          tip="Deliveries they already completed keep their record — only the rider account goes."
          confirmText="Remove"
          loading={this.state.actionLoading}
        />
      </ConsolePage>
    );
  }
}

export default DeliveryBoy;
